import Enumeration from "./enumeration";

/** @type {Enumeration} System defaults */
export default new Enumeration({
  LANGUAGE: "en-US",
  CURRENCY: "USD",
});
